module.exports = {
  __depends__: [
    require(219),
    require(233)
  ],
  bpmnReplace: [ 'type', require(78) ]
};
